/**
 * Resultado del flujo OAuth (Google / Microsoft) para Parámetros de correo.
 * Se abre en ventana emergente; notifica al opener y se cierra.
 */
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const PROVIDER_LABELS = {
  google: "Google / Gmail",
  microsoft: "Microsoft / Outlook",
};

export default function EmailOAuthResultPage() {
  const [searchParams] = useSearchParams();
  const [closing, setClosing] = useState(false);
  const status = searchParams.get("status") || "error";
  const provider = searchParams.get("provider") || "";
  const detail = searchParams.get("detail") || "";
  const ok = status === "success";
  const providerLabel = PROVIDER_LABELS[provider] || provider || "correo";

  useEffect(() => {
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage(
        { type: "vf_email_oauth_done", status, provider, detail },
        window.location.origin,
      );
      const timer = window.setTimeout(() => {
        setClosing(true);
        window.close();
      }, 1200);
      return () => window.clearTimeout(timer);
    }
    return undefined;
  }, [status, provider, detail]);

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 p-6">
      <div className="max-w-md w-full rounded-sm border border-slate-200 bg-white p-6 shadow-sm text-center space-y-4">
        {ok ? (
          <CheckCircle2 className="h-12 w-12 text-emerald-600 mx-auto" aria-hidden />
        ) : (
          <XCircle className="h-12 w-12 text-red-600 mx-auto" aria-hidden />
        )}
        <h1 className="text-lg font-semibold text-slate-900 m-0">
          {ok ? "Cuenta conectada" : "No se pudo conectar"}
        </h1>
        <p className="text-sm text-slate-600 m-0">
          {ok
            ? `Su cuenta ${providerLabel} quedó vinculada. Los correos saldrán desde esa dirección.`
            : detail || "Revise los permisos o intente de nuevo desde Parámetros de correo."}
        </p>
        {closing ? (
          <p className="text-xs text-slate-500 flex items-center justify-center gap-2 m-0">
            <Loader2 className="h-3.5 w-3.5 animate-spin" aria-hidden />
            Cerrando ventana…
          </p>
        ) : (
          <Button
            type="button"
            variant="outline"
            className="rounded-sm"
            onClick={() => window.close()}
          >
            Cerrar
          </Button>
        )}
      </div>
    </div>
  );
}
